class ContactUsForm extends HTMLElement {
  connectedCallback() {
    this.subjectSelect = this.querySelector('select[name="contact[Ärende]"]');
    this.reklamationBlock = this.querySelector('[data-reklamation]');
    this.uploadInput = this.querySelector('[data-upload-input]');
    this.uploadList = this.querySelector('[data-upload-list]');
    this.dropzone = this.querySelector('[data-upload] .contact-us-form__dropzone');

    if (!this.subjectSelect || !this.reklamationBlock) return;

    this.reklamationFields = Array.from(
      this.reklamationBlock.querySelectorAll('input, select, textarea')
    );

    this.requiredFieldNames = new Set([
      'contact[Klagomål]',
      'contact[Produkt]',
      'contact[Inköpsställe]',
      'contact[Inköpsdatum]',
      'contact[Bilder][]',
      'contact[Address]',
      'contact[Stad]',
      'contact[Postnummer]',
      'contact[Födelsedatum]',
    ]);

    this.subjectSelect.addEventListener('change', () => this.syncReklamationVisibility());
    this.syncReklamationVisibility();

    if (this.uploadInput) {
      this.uploadInput.addEventListener('change', () => this.renderUploads());
      this.setupDropzone();
    }
  }

  syncReklamationVisibility() {
    const isReklamation = this.subjectSelect.value === 'Reklamation';
    this.reklamationBlock.hidden = !isReklamation;

    this.reklamationFields.forEach((field) => {
      field.disabled = !isReklamation;
      if (this.requiredFieldNames.has(field.name)) {
        field.required = isReklamation;
      }
    });
  }

  setupDropzone() {
    if (!this.dropzone) return;

    const prevent = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((evt) => {
      this.dropzone.addEventListener(evt, prevent);
    });

    this.dropzone.addEventListener('drop', (e) => {
      if (!e.dataTransfer?.files?.length) return;
      const dt = new DataTransfer();
      Array.from(this.uploadInput.files).forEach((f) => dt.items.add(f));
      Array.from(e.dataTransfer.files).forEach((f) => dt.items.add(f));
      this.uploadInput.files = dt.files;
      this.uploadInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    this.dropzone.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.uploadInput.click();
      }
    });
  }

  renderUploads() {
    if (!this.uploadList) return;
    const files = Array.from(this.uploadInput.files || []);

    this.uploadList.innerHTML = '';
    this.uploadList.hidden = files.length === 0;

    files.forEach((file, index) => {
      const item = document.createElement('li');
      item.className = 'contact-us-form__upload-item';

      const img = document.createElement('img');
      img.src = URL.createObjectURL(file);
      img.alt = file.name;
      img.addEventListener('load', () => URL.revokeObjectURL(img.src), { once: true });

      const removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'contact-us-form__upload-remove';
      removeBtn.setAttribute('aria-label', `Ta bort ${file.name}`);
      removeBtn.textContent = '✕';
      removeBtn.addEventListener('click', () => this.removeFile(index));

      item.append(img, removeBtn);
      this.uploadList.append(item);
    });
  }

  removeFile(index) {
    const dt = new DataTransfer();
    Array.from(this.uploadInput.files).forEach((file, i) => {
      if (i !== index) dt.items.add(file);
    });
    this.uploadInput.files = dt.files;
    this.renderUploads();
  }
}

customElements.define('contact-us-form', ContactUsForm);
